import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { GetLocationQuery } from '@/query';
import { getInitialSearchState } from '@/utils';
import { getListingsVariables } from './api_utils';

async function findLocationById(locationId, client) {
  if (!locationId) return null;
  const res = await client.query({
    query: GetLocationQuery,
    variables: { locationSlug: locationId },
    errorPolicy: 'ignore',
  });
  return res?.data?.location || null;
}

export function useSearchState(query) {
  const client = useApolloClient();
  const [loading, setLoading] = useState(true);
  const [searchState, setSearchState] = useState(() =>
    getInitialSearchState({}),
  );
  const [variables, setVariables] = useState(() => getListingsVariables());

  useEffect(() => {
    async function extractFromQuery() {
      let fullLocation;
      try {
        fullLocation = await findLocationById(query.locationId, client);
      } catch {
        fullLocation = {};
      }
      const search = getInitialSearchState({
        ...query,
        locationName: fullLocation?.name,
        locationType: fullLocation?.type,
      });
      const variables = getListingsVariables(
        search.inexactStay,
        search.guests,
        search.location,
        search.pets,
        search.date,
        search.price,
        search.amenities,
        search.rooms,
        search.rating,
        search.tab,
      );
      setSearchState(search);
      setVariables(variables);
      setLoading(false);
    }
    extractFromQuery();
  }, [JSON.stringify(query), setSearchState, setVariables]);
  return { searchState, variables, loading };
}
